export const BUTTON_SLIDE_SIZE = 64;
export const BUTTON_SLIDE_SIZE_MEDIUM = 56;
export const BUTTON_SLIDE_SIZE_SMALL = 48;
